export const galleryImages = [
  {
    id: 1,
    src: '/assets/images/gallery/exterior-1.jpg',
    alt: 'BMW exterior detailing',
    altAr: 'تلميع خارجي بي إم دبليو',
    category: 'exterior',
    title: 'BMW Full Detailing',
    titleAr: 'تلميع بي إم دبليو كامل',
    description: 'Complete exterior foam wash and wax polish',
    descriptionAr: 'غسيل فوم خارجي كامل مع تلميع واكس',
  },
  {
    id: 2,
    src: '/assets/images/gallery/interior-1.jpg',
    alt: 'Mercedes interior cleaning',
    altAr: 'تنظيف داخلي مرسيدس',
    category: 'interior',
    title: 'Mercedes Interior Deep Clean',
    titleAr: 'تنظيف عميق لداخلية مرسيدس',
    description: 'Leather conditioning and interior sanitization',
    descriptionAr: 'ترطيب الكراسي الجلد وتعقيم المقصورة الداخلية',
  },
  {
    id: 3,
    src: '/assets/images/gallery/engine-1.jpg',
    alt: 'Engine bay cleaning',
    altAr: 'تنظيف مكينة السيارة',
    category: 'engine',
    title: 'Engine Bay Detailing',
    titleAr: 'تلميع محرك السيارة',
    description: 'Complete engine degreasing and cleaning',
    descriptionAr: 'إزالة الزيوت وتنظيف المحرك بالكامل',
  },
  {
    id: 4,
    src: '/assets/images/gallery/coating-1.jpg',
    alt: 'Ceramic coating application',
    altAr: 'حماية نانو سيراميك',
    category: 'coating',
    title: 'Ceramic Coating',
    titleAr: 'حماية نانو سيراميك 9H',
    description: '9H ceramic coating application',
    descriptionAr: 'تطبيق حماية النانو سيراميك الأصلية 9H',
  },
  {
    id: 5,
    src: '/assets/images/gallery/polish-1.jpg',
    alt: 'Paint correction and polishing',
    altAr: 'تصحيح وتلميع صبغ السيارة',
    category: 'polish',
    title: 'Paint Correction',
    titleAr: 'تصحيح الصبغ',
    description: 'Professional paint correction service',
    descriptionAr: 'خدمة احترافية لتصحيح صبغ السيارة وإزالة الخدوش',
  },
  {
    id: 6,
    src: '/assets/images/gallery/full-1.jpg',
    alt: 'Complete car detailing',
    altAr: 'تلميع سيارات متنقل كامل',
    category: 'full',
    title: 'Complete Detailing Package',
    titleAr: 'باقة التلميع الشاملة',
    description: 'Full interior and exterior detailing',
    descriptionAr: 'تلميع داخلي وخارجي شامل بأعلى جودة',
  },
  {
    id: 7,
    src: '/assets/images/gallery/exterior-2.jpg',
    alt: 'Range Rover exterior wash',
    altAr: 'غسيل رنج روفر خارجي',
    category: 'exterior',
    title: 'Range Rover Wash',
    titleAr: 'غسيل رنج روفر',
    description: 'Premium foam wash and tire dressing',
    descriptionAr: 'غسيل فوم بريميوم مع تلميع الإطارات',
  },
  {
    id: 8,
    src: '/assets/images/gallery/interior-2.jpg',
    alt: 'Lexus interior detailing',
    altAr: 'تلميع داخلية لكزس',
    category: 'interior',
    title: 'Lexus Interior Care',
    titleAr: 'عناية داخلية لكزس',
    description: 'Complete interior vacuum and conditioning',
    descriptionAr: 'تنظيف وشفط أتربة وترطيب كامل للداخلية',
  },
  {
    id: 9,
    src: '/assets/images/gallery/coating-2.jpg',
    alt: 'Glass coating application',
    altAr: 'حماية زجاج السيارة',
    category: 'coating',
    title: 'Glass Coating',
    titleAr: 'حماية الزجاج',
    description: 'Water repellent glass coating',
    descriptionAr: 'طبقة حماية للزجاج طاردة للمياه والأمطار',
  },
];

export const beforeAfterSlides = [
  {
    id: 1,
    before: '/assets/images/before-after/engine-before.jpg',
    after: '/assets/images/before-after/engine-after.jpg',
    title: 'Engine Bay Transformation',
    titleAr: 'تحول محرك السيارة',
    description: 'From greasy to gleaming - complete engine bay detailing',
    descriptionAr: 'من الزيوت والأوساخ إلى لمعان الوكالة - تنظيف شامل للمحرك',
  },
  {
    id: 2,
    before: '/assets/images/before-after/interior-before.jpg',
    after: '/assets/images/before-after/interior-after.jpg',
    title: 'Interior Makeover',
    titleAr: 'تجديد المقصورة الداخلية',
    description: 'Deep cleaning and leather restoration',
    descriptionAr: 'تنظيف عميق واستعادة حيوية الجلد',
  },
  {
    id: 3,
    before: '/assets/images/before-after/exterior-before.jpg',
    after: '/assets/images/before-after/exterior-after.jpg',
    title: 'Paint Restoration',
    titleAr: 'استعادة لمعان الصبغ',
    description: 'Removing scratches and restoring shine',
    descriptionAr: 'إزالة الخدوش البسيطة واستعادة لمعة الوكالة',
  },
];
